import createClient from 'openapi-fetch'
import { rename } from '../helpers/helper.core'
import type { paths } from '../types/integrations/core/operations'
import { getMiddleware } from './utils'
import type {
  CoreBudgetRequest,
  EventsRequest,
  SaveAccountExtensionSigningRequest,
  SaveBudgetSigningRequest,
  SetOptionalSetupRequest,
  SetPictureRequest,
  UpdateBudgetRemainingPercentRequest,
  UpdateCarRequest,
  UpdateFlowStatusRequest,
} from '../types/integrations/core/common'

const coreClient = createClient<paths>({
  baseUrl: 'http://integration-proxy-api/core',
})
coreClient.use(getMiddleware())

export async function getFlowStatus() {
  const { data } = await coreClient.GET('/GetFlowStatus')
  return rename(data)
}

export async function updateFlowStatus(body: UpdateFlowStatusRequest) {
  const { data } = await coreClient.PUT('/UpdateFlowStatus', { body })
  return rename(data)
}

export async function getCoreEvent(fromDate?: string, fromEntryNo?: number) {
  const { data } = await coreClient.GET('/GetCoreEvent', {
    params: { query: { fromDate, fromEntryNo } },
  })
  return rename(data)
}

export async function events(body: EventsRequest) {
  const { data } = await coreClient.POST('/Events', { body })
  return rename(data)
}

export async function updateCar(body: UpdateCarRequest) {
  const { data } = await coreClient.PUT('/UpdateCar', { body })
  return rename(data)
}

export async function getBudget(budgetID: string) {
  const { data } = await coreClient.GET('/GetBudget', {
    params: { query: { budgetID } },
  })
  return rename(data)
}

export async function getBudgetSigning(budgetID: string) {
  const { data } = await coreClient.GET('/GetBudgetSigning', { params: { query: { budgetID } } })
  return rename(data)
}

export async function saveBudgetSigning(body: SaveBudgetSigningRequest) {
  const { data } = await coreClient.POST('/SaveBudgetSigning', { body })
  return rename(data)
}

export async function updateBudgetRemainingPercent(body: UpdateBudgetRemainingPercentRequest) {
  const { data } = await coreClient.PUT('/UpdateBudgetRemainingPercent', { body })
  return rename(data)
}

export async function getOptionalSetup() {
  const { data } = await coreClient.GET('/GetOptionalSetup')
  return rename(data)
}

export async function setOptionalSetup(body: SetOptionalSetupRequest) {
  const { data } = await coreClient.POST('/SetOptionalSetup', { body })
  return rename(data)
}

export async function getAccountExtensionSigning(extensionNo: string) {
  const { data } = await coreClient.GET('/GetAccountExtensionSigning', { params: { query: { extensionNo } } })
  return rename(data)
}

export async function saveAccountExtensionSigning(body: SaveAccountExtensionSigningRequest) {
  const { data } = await coreClient.POST('/SaveAccountExtensionSigning', { body })
  return rename(data)
}

export async function getBudgetDataExtension(extensionNo: string) {
  const { data } = await coreClient.GET('/GetBudgetDataExtension', { params: { query: { extensionNo } } })
  return rename(data)
}

export async function setPicture(carBudgetNo: string, body: SetPictureRequest) {
  const { data } = await coreClient.POST('/SetPicture', {
    body,
    params: {
      query: {
        carBudgetNo,
      },
    },
  })
  return rename(data)
}

export async function getAccountInvoicedDirectCost() {
  const { data } = await coreClient.GET('/GetAccountInvoicedDirectCost')
  return rename(data)
}

export async function postQuote(body: CoreBudgetRequest, budgetNo: number) {
  const { data } = await coreClient.POST('/PostQuoteImproved', {
    body,
    params: {
      query: {
        quoteId: String(budgetNo),
      },
    },
  })
  return rename(data)
}

export async function getCoreDocuments(signerEmail: string, pageSize?: number) {
  const { data } = await coreClient.GET('/GetCoreDocuments', {
    params: { query: { signerEmail, ...(pageSize && pageSize > 0 ? { pageSize } : {}) } },
  })
  return rename(data)
}

export async function getDocumentBase64(budgetNo?: string, documentNo?: number, accountNo?: string) {
  const { data } = await coreClient.GET('/GetDocumentBase64', {
    params: { query: { budgetNo, documentNo, accountNo } },
  })
  return rename(data)
}
